module.exports = __webpack_public_path__ + "img/famen.110dc2b9.png";